module.exports = __webpack_public_path__ + "static/media/3-custom-cut-passepartout-board-for-ikea-SILVERHOJDEN-frame-(16in-x-12in-(41cm-x-31cm).8a68f4cc.webp";